import * as Actions  from 'reduxpath/action-type';


const initialState = {
    isNC65: false,
    thirdPart: [],
    content : "",
    isOnlyCode : false,
    isExclusive : false,
    userInfo: null,
    casurl: ''
};


export default (state = initialState, action) => {
        switch (action.type) {
            case Actions.UpdateCommonInfo:
                return Object.assign({}, state, action.data);
            default:
                return state;
        }
}